import React from 'react';
import axios from 'axios';
import Helpers from "../../../../lib/helpers";
import LoadingSmall from "../LoadingSmall";

class EstimatePackageUsage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value:'',
            isLoading:false,
            result:false,
        }
    }

    calculate = () => {
        if(this.state.value == '') {
            return;
        }

        let domain = 'https://api.crall.io';
        if(!Helpers.isProduction()) {
            domain = 'https://api.crall.dev';
        }

        this.setState({
            isLoading:true,
        })

        axios.get(`${domain}/plans/estimate?sessions=${this.state.value}`).then((result) => {
            this.setState({
                isLoading:false,
                result:result.data
            })

            this.props.handleResult(result.data);
        });
    }

    changeInput = (e) => {
        this.setState({
            value:e.target.value,
        })
    }

    render() {
        return (
            <div className="col-sm-12" style={{backgroundColor:'#fafafa',padding:'10px',border:'1px solid #efefef'}}>
                <div className="col-sm-12" style={{marginBottom:'10px'}}>
                    {this.props.children}

                </div>
                <div className="col-sm-8">
                    <input className="form-control" value={this.state.value} onChange={this.changeInput} placeholder="Number of sessions" />
                </div>
                <div className="col-sm-4">
                    {
                        this.state.isLoading ?
                            <LoadingSmall />
                            :
                            <button className="btn btn-dark btn-block" onClick={this.calculate}>Estimate package</button>
                    }
                </div>

            </div>
        );
    }


}

export default EstimatePackageUsage;




// WEBPACK FOOTER //
// ./components/widgets/EstimatePackageUsage.js